import { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import HourlyRate from "./HourlyRate";
import { withTranslation } from "react-i18next";
import styles from "../staff.module.scss";
import LeaveDetail from "./LeaveDetail";
import fileIcon from "assets/images/file-icon.svg";
import jobHourIcon from "assets/images/job-hour.svg";
import DataBox from "./DataBox";
import Text from "components/Text";
const TabsView = ({
  isHourlyRateCanView,
  staffDetails,
  reviewFormList,
  officeId,
  t,
  staffLeaves,
}) => {
  const [activeTab, setActiveTab] = useState("1");
  const [hideShow, setHideShow] = useState(false);
  const {
    commission = "0",
    // commissionType = "1",
    bonus = "0",
    // bonusType = "1",
    vacationPaidOff,
    annualSalary,
    travelAllowance,
    educationAllowance,
    uniformAllowance,
    otherAllowance,
    signingBonus,
    annualBonus,
  } = staffDetails;
  useEffect(() => {
    setHideShow(false);
  }, [staffDetails.id]);
  useEffect(() => {
    if (hideShow) {
      setHideShow(false);
    }
  }, [activeTab]);
  const renderName = (value) => (hideShow ? value : "XX");
  return (
    <>
      <Text size="15px" weight="600" className={`${styles["mt-30"]} ${styles["mb-20"]} ${styles["text-staff-primary"]}`}>
        Compensation
        <button
          className="link-btn bg-transparent border border-0 float-right"
          onClick={() => {
            setHideShow((prev) => !prev);
          }}
        >
          {hideShow ? "Hide" : "Show"}
        </button>
      </Text>
      <div className={styles["tabs-view"] + " common-tabs"}>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => setActiveTab("1")}
            >
              Salary
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => setActiveTab("2")}
            >
              Commission
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "3" ? "active" : ""}
              onClick={() => setActiveTab("3")}
            >
              Bonus
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "4" ? "active" : ""}
              onClick={() => setActiveTab("4")}
            >
              Allowances
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "5" ? "active" : ""}
              onClick={() => setActiveTab("5")}
            >
              Leave & Time Off
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            {isHourlyRateCanView && (
              <HourlyRate
                staffDetails={staffDetails}
                selectedReview={reviewFormList}
                officeId={officeId}
                hourlyView
                hideShow={hideShow}
              />
            )}
            <DataBox icon={jobHourIcon} label={t("staff.annualSalary")}>
              {+annualSalary
                ? (hideShow ? annualSalary : "XX") + " " + t("staff.cad")
                : "--"}
            </DataBox>
          </TabPane>
          <TabPane tabId="2">
            <DataBox label="Commission" icon={jobHourIcon}>
              {commission ? renderName(commission) : "--"}
            </DataBox>
          </TabPane>
          <TabPane tabId="3">
            <DataBox label="Bonus" icon={jobHourIcon}>
              {bonus ? renderName(bonus) : "--"}
            </DataBox>
            <DataBox label="Annual Bonus" icon={jobHourIcon}>
              {annualBonus ? renderName(annualBonus) : "--"}
            </DataBox>
            <DataBox label="Signing Bonus" icon={jobHourIcon}>
              {signingBonus ? renderName(signingBonus) : "--"}
            </DataBox>
          </TabPane>
          <TabPane tabId="4">
            <DataBox label="Travel" icon={jobHourIcon}>
              {travelAllowance ? renderName(travelAllowance) : "--"}
            </DataBox>
            <DataBox label="Continuing Education" icon={jobHourIcon}>
              {educationAllowance ? renderName(educationAllowance) : "--"}
            </DataBox>
            <DataBox label="Uniform Allowance" icon={jobHourIcon}>
              {uniformAllowance ? renderName(uniformAllowance) : "--"}
            </DataBox>
            <DataBox label="Other" icon={jobHourIcon}>
              {otherAllowance ? renderName(otherAllowance) : "--"}
            </DataBox>
          </TabPane>
          <TabPane tabId={"5"}>
            <DataBox label="Vacation / Paid Time Off" icon={fileIcon}>
              {vacationPaidOff ? renderName(vacationPaidOff) : "--"}
            </DataBox>
            <LeaveDetail staffLeaves={staffLeaves} renderName={renderName} />
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};
export default withTranslation()(TabsView);
